<template>
  <div class="sky-page-report-view">
    <div class="el-icon-question wsp-padding-lr-6 wsp-line-height-24">
      客户环境采集可点击右侧工具进行下载（支持Windows7/Windows10/Windows11）
      <span class="collect-group-title-tool sk-link--normal el-icon-download" @click="downloadCollectTool()">
        环境采集工具下载
      </span>
    </div>
    <div class="collect-group-title-tip"></div>

    <div class="page-function-toolbar">
      <el-button type="primary" @click="handleReturnSelection">确定</el-button>
      <el-button icon="el-icon-refresh" @click="refushTable"></el-button>
      <el-input
        placeholder="请输入编号/客户/客户岗位/数据包名/联系人模糊筛选"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>

      <el-pagination
        class="toolbar-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handelPrev"
        @next-click="handelNext"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="total,sizes,prev,sp,next"
        :current-page="page"
        :page-size="pageSize"
        :total="pageTotal"
      >
      </el-pagination>
    </div>

    <el-table
      ref="table"
      :border="true"
      :data="specFeatureList"
      :key="reportKey"
      :show-header="true"
      :column-drag-sortable="false"
      class="sky-host-dist  deploy-porject-report"
      @sort-change="handelSortChange"
      @selection-change="selectEvent"
    >
      <el-table-column type="radio" width="55" header-row-class-name="xxxxxxxx"> </el-table-column>
      <el-table-column label="编号" prop="number" width="75"> </el-table-column>
      <el-table-column label="客户" prop="customer" show-overflow-tooltip> </el-table-column>
      <el-table-column label="客户岗位" prop="customerPosition" show-overflow-tooltip> </el-table-column>
      <!-- <el-table-column label="数据包名" prop="dataName" show-overflow-tooltip> </el-table-column> -->
      <!-- <el-table-column label="联系人" prop="contactPerson" width="105" show-overflow-tooltip> </el-table-column> -->
      <el-table-column label="导入时间" prop="createTimeCh" sortable="custom" width="105" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="采集时间" prop="collectTimeCh" sortable="custom" width="105" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Drawer, Pagination, Input } from 'element-ui'

import { getCollectList } from '@/api/collect'
import { timestampToTime } from '@/utils/timeUtil'

export default {
  name: 'SkyDeployReportTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Pagination.name]: Pagination,
    [Input.name]: Input
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      searchKeyword: null,
      shwoFunViewDetail: {},
      selectFuntion: [],
      pageTotal: 0,
      pageSize: 20,
      specFeatureList: [],
      selectRowTempList: [],
      selectRow: null,
      tableAllSelectIdList: [],
      noInTablReportList: [],
      reportKey: true,
      page: 1,
      reqParmas: {
        matchArr: [],
        page: this.page - 1,
        limit: 20,
        sortArr: [{ fieldName: 'createTime', direction: 'DESC' }]
      }
    }
  },
  created() {
    if (this.params.projectId) {
      this.reqParmas.matchArr.push({
        type: 'EXACT',
        fieldName: 'projectId',
        valueArr: [this.params.projectId],
        matchRule: 'EQ'
      })
    }
  },
  mounted() {
    if (this.params.collectReportDTOList) {
      this.tableAllSelectIdList = this.params.collectReportDTOList
    }
    this.getData()
  },
  methods: {
    refushTable() {
      this.getData()
    },
    searchReq() {
      if (this.searchKeyword || this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['number', 'customer', 'customerPosition', 'dataName', 'contactPerson'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    // getNotInTableReport() {
    //   var tableIdList = this.specFeatureList.map(obj => obj.id)
    //   this.noInTablReportList = []
    //   this.selectRowTempList = []
    //   for (const iterator of this.tableAllSelectIdList) {
    //     if (!tableIdList.includes(iterator.id)) {
    //       this.noInTablReportList.push(iterator)
    //     } else {
    //       this.selectRowTempList.push(iterator)
    //     }
    //   }
    // },
    refreshSelect() {
      var reportIdArr = []
      if (this.selectRow) {
        reportIdArr.push(this.selectRow.id)
      }
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
        this.specFeatureList.forEach(row => {
          //判断 元素是否已经被勾选，那就选中
          if (reportIdArr.includes(row.id)) {
            this.$refs.table.toggleRowSelection(row, true)
          }
        })
      })
    },
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getCollectList(this.reqParmas).then(res => {
        this.specFeatureList = res.data.content.itemArr
        this.specFeatureList.forEach(element => {
          element.createTimeCh = timestampToTime(element.createTime)
          element.collectTimeCh = timestampToTime(element.collectTime)
        })
        this.reportKey = !this.reportKey
        this.pageTotal = res.data.content.total
        // this.getNotInTableReport()
        // this.refreshSelect()
      })
    },
    handelSortChange(event, aaa) {
      const exists = this.reqParmas.sortArr.some(obj => obj.fieldName === event.prop)
      if (exists) {
        for (const iterator of this.reqParmas.sortArr) {
          if (iterator.fieldName === event.prop) {
            iterator.direction = 'ascending' === event.order ? 'ASC' : 'DESC'
          }
        }
      } else {
        this.reqParmas.sortArr.push({ fieldName: event.prop, direction: 'ascending' === event.order ? 'ASC' : 'DESC' })
      }
      this.reqParmas.sort = { fieldName: event.prop, direction: 'ascending' === event.order ? 'ASC' : 'DESC' }
      this.getData()
    },
    handleReturnSelection() {
      if (!this.selectRow) {
        this.$store.dispatch('OpenNotification', { message: '请选择要绑定的报告', type: 'error' })
        return
      }

      // var merageArr = this.selectRowTempList.concat(this.noInTablReportList)

      this.$emit('chagneSceneRelation', {
        select: this.selectRow
      })
    },
    // selectAllEvent(selection) {
    //   var reportIdArr = this.specFeatureList.map(obj => obj.id)
    //   if (selection.length === 0) {
    //     //移除
    //     this.selectRowTempList = this.selectRowTempList.filter(obj => !reportIdArr.includes(obj.id))
    //   } else {
    //     //增加
    //     var tempReportIdArr = this.selectRowTempList.map(obj => obj.id)
    //     selection.forEach(row => {
    //       if (!tempReportIdArr.includes(row.id)) {
    //         this.selectRowTempList.push(row)
    //       }
    //     })
    //   }
    // },
    selectEvent(select) {
      if (select.length > 0) {
        this.selectRow = select[0]
      } else {
        this.selectRow = null
      }
      // this.refreshSelect()
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.page = 1
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-report-view) {
  height: 100%;
  padding: 0 12px;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
  .deploy-porject-report .el-table__header-wrapper .has-gutter tr .el-table-column--selection .cell {
    display: none !important;
  }
}
</style>
